import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const CevreDanismanligiPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[500px] bg-gradient-to-r from-blue-900 via-blue-800 to-indigo-900 overflow-hidden mt-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 border-2 border-white rounded-full animate-pulse"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 h-full flex items-center">
          <div className="text-white max-w-3xl">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center mr-4">
                <i className="ri-leaf-line text-6xl text-blue-300"></i>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold">Çevre Danışmanlığı</h1>
            </div>
            <p className="text-xl md:text-2xl text-blue-100 leading-relaxed">
              Sürdürülebilir çevre yönetimi ve mevzuata uyum için profesyonel danışmanlık hizmetleri
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          {/* Service Areas, Benefits, Process - 3 Cards Side by Side */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            {/* Hizmet Alanlarımız */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200 flex flex-col h-full">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-service-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Hizmet Alanlarımız</h3>
              </div>
              <div className="space-y-4 flex-grow">
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-line text-blue-600 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Çevresel İzin ve Raporlama</h4>
                    <p className="text-sm text-gray-600">Yasal izin süreçleri ve raporlama desteği</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-line text-blue-600 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Emisyon Kontrolü</h4>
                    <p className="text-sm text-gray-600">Hava emisyonları ölçüm ve kontrol</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-line text-blue-600 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Atık Su Yönetimi</h4>
                    <p className="text-sm text-gray-600">Atık su arıtma ve deşarj izinleri</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-line text-blue-600 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Gürültü Kontrolü</h4>
                    <p className="text-sm text-gray-600">Çevresel gürültü ölçüm ve azaltma</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Sürdürülebilirlik Faydaları */}
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-2xl p-8 border border-indigo-200 flex flex-col h-full">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-plant-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Sürdürülebilirlik Faydaları</h3>
              </div>
              <div className="space-y-4 flex-grow">
                <div className="bg-white rounded-lg p-4 shadow-sm border border-indigo-100">
                  <div className="flex items-center mb-2">
                    <i className="ri-leaf-line text-indigo-600 mr-2"></i>
                    <span className="font-semibold text-gray-800">Çevre Dostu İşletme</span>
                  </div>
                  <p className="text-sm text-gray-600">Çevresel etkileri minimize ederek sürdürülebilir üretim</p>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-sm border border-indigo-100">
                  <div className="flex items-center mb-2">
                    <i className="ri-money-dollar-circle-line text-indigo-600 mr-2"></i>
                    <span className="font-semibold text-gray-800">Maliyet Tasarrufu</span>
                  </div>
                  <p className="text-sm text-gray-600">Enerji ve kaynak verimliliği ile tasarruf</p>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-sm border border-indigo-100">
                  <div className="flex items-center mb-2">
                    <i className="ri-shield-check-line text-indigo-600 mr-2"></i>
                    <span className="font-semibold text-gray-800">Yasal Uyumluluk</span>
                  </div>
                  <p className="text-sm text-gray-600">Çevre mevzuatına tam uyum sağlama</p>
                </div>
              </div>
            </div>

            {/* Danışmanlık Süreci */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 border border-orange-200 flex flex-col h-full">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-roadmap-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Danışmanlık Süreci</h3>
              </div>
              <div className="space-y-4 flex-grow">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center font-bold mr-3 flex-shrink-0">1</div>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Mevcut Durum Analizi</h4>
                    <p className="text-sm text-gray-600">İşletmenizin çevresel durumunu değerlendiriyoruz</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center font-bold mr-3 flex-shrink-0">2</div>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Eylem Planı Hazırlama</h4>
                    <p className="text-sm text-gray-600">Özel çözüm önerileri ve yol haritası</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center font-bold mr-3 flex-shrink-0">3</div>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Uygulama ve İzleme</h4>
                    <p className="text-sm text-gray-600">Sürekli destek ve performans takibi</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 3 Main Service Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 auto-rows-fr">
            {/* Card 1 */}
            <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-2xl p-8 border border-sky-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col">
              <div className="w-20 h-20 bg-gradient-to-br from-sky-500 to-sky-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className="ri-leaf-line text-3xl text-white"></i>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Çevresel Etki Değerlendirmesi</h3>
              <p className="text-gray-700 leading-relaxed text-center flex-grow">
                İşletmenizin çevresel etkilerini kapsamlı bir şekilde analiz ediyor, iyileştirme önerileri sunuyoruz.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 border border-amber-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className="ri-recycle-line text-3xl text-white"></i>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Atık Yönetimi Danışmanlığı</h3>
              <p className="text-gray-700 leading-relaxed text-center flex-grow">
                Atık azaltma, geri dönüşüm ve bertaraf süreçlerinizi optimize ederek çevresel ayak izinizi azaltıyoruz.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-2xl p-8 border border-cyan-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col">
              <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className="ri-water-flash-line text-3xl text-white"></i>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Su ve Hava Kalitesi Yönetimi</h3>
              <p className="text-gray-700 leading-relaxed text-center flex-grow">
                Su ve hava kalitesi standartlarına uyum sağlayarak çevresel sorumluluklarınızı yerine getirmenize yardımcı oluyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default CevreDanismanligiPage;
